import { render, staticRenderFns } from "./MetaDataDisplay.vue?vue&type=template&id=4f270d1e"
import script from "./MetaDataDisplay.vue?vue&type=script&lang=js"
export * from "./MetaDataDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports